import RadioFieldV2 from '@zola/zola-ui/src/components/Form/RadioFieldV2/RadioField/RadioFieldV2';
import {
  RadioFieldWrapper,
  SelectorLabel,
} from '@zola/zola-ui/src/components/Form/RadioFieldV2/RadioField/RadioFieldV2.styles';
import { BaseSideDrawer } from '@zola/zola-ui/src/components/SideDrawer';

import styled from '@emotion/styled';

export const FacetSideDrawerRadio = styled(RadioFieldV2)`
  ${SelectorLabel} {
    padding: 0 0 16px;
  }
`;

export const StyledFacetSideDrawer = styled(BaseSideDrawer)`
  ${RadioFieldWrapper}:last-child {
    ${SelectorLabel} {
      padding: 0;
    }
  }
`;
